import FingerprintJS from '@fingerprintjs/fingerprintjs'

export default {
  fingerprint: null,

  async get() {
    if (this.fingerprint) {
      return this.fingerprint
    }

    console.time('FP')
    const fp = await FingerprintJS.load()

    const result = await fp.get()
    const { architecture, cpuClass, deviceMemory, hardwareConcurrency, osCpu, platform, vendor, timezone, fonts, languages, plugins } = result.components

    const visitorId = FingerprintJS.hashComponents({
      architecture,
      cpuClass,
      deviceMemory,
      hardwareConcurrency,
      osCpu,
      platform,
      vendor,
      timezone,
      fonts,
      languages,
      plugins
    })
    this.fingerprint = visitorId

    console.timeEnd('FP')
    return this.fingerprint
  },

  async getPlatform() {
    const fp = await FingerprintJS.load()

    const { components } = await fp.get()

    return components.platform.value || 'ND'
  }
}
